import { render, staticRenderFns } from "./batchDataImport.vue?vue&type=template&id=51ec4ef2&scoped=true"
import script from "./batchDataImport.vue?vue&type=script&lang=js"
export * from "./batchDataImport.vue?vue&type=script&lang=js"
import style0 from "./batchDataImport.vue?vue&type=style&index=0&id=51ec4ef2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec4ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ec4ef2')) {
      api.createRecord('51ec4ef2', component.options)
    } else {
      api.reload('51ec4ef2', component.options)
    }
    module.hot.accept("./batchDataImport.vue?vue&type=template&id=51ec4ef2&scoped=true", function () {
      api.rerender('51ec4ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/personnelDetail/batchDataImport.vue"
export default component.exports